import * as Yup from 'yup';
export const initialClinicValues = {
    name: '',
    phoneNumber: '',
};
export const clkinicSchema = Yup.object().shape({
    name: Yup.string(),
    phoneNumber: Yup.string(),
});
//# sourceMappingURL=clinic.js.map